import { Grid, Skeleton } from "@mui/material";

const FormSkeleton = () => {
  return (
    <Grid container spacing={3} sx={{ padding: 2 }}>
      <Grid item xs={12}>
        <Skeleton
          variant="text"
          width="60%"
          height={32}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: 0.5,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default FormSkeleton;
